import React, { memo } from 'react';
import { Stack } from 'investira.react.components';
import { BaseTemplate } from '../../components/templates';
import { SearchGlobal } from '../../components/organisms';
import Posicao from './_components/Posicao/Posicao';
// import useAssinatura from '../../hooks/useAssinatura';

const Dashboard = memo(() => {
  return (
    <BaseTemplate title="Dashboard">
      <Stack
        spacing={4}
        sx={{
          py: 2
        }}>
        <SearchGlobal />
        <Posicao />
        {/*<Benchmarks />
         <Empresas /> */}
      </Stack>
    </BaseTemplate>
  );
});
Dashboard.displayName = 'Dashboard';
export default Dashboard;
